import { render, staticRenderFns } from "./CoolingLoadVSOAT.vue?vue&type=template&id=d642e30c&"
import script from "./CoolingLoadVSOAT.vue?vue&type=script&lang=js&"
export * from "./CoolingLoadVSOAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports